import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: min(4.69vw, 67px) min(13.93vw, 199px) min(1.89vw, 27px);
  align-items: center;
  background-color: #eee;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  align-items: center;
  flex-direction: column;
  .news-room-heading {
    font-size: min(3.85vw, 60px);
    line-height: min(3.78vw, 54px);
    color: #000;
    letter-spacing: -0.66px;
    font-family: "robotoblack";
    margin-bottom: min(3.08vw, 44px);
    text-align: center;
  }
  .news-room-sub-heading {
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    letter-spacing: -0.66px;
    font-family: "robotobold";
    margin-bottom: min(3.08vw, 44px);
    color: #095587;
    text-align: center;
  }
  .banner-image {
    width: min(72.87vw, 1041px);
    max-width: 100%;
    margin: 0 auto min(4.9vw, 70px);
  }
  @media (max-width: 767px) {
    padding: min(4.69vw, 67px);
    .banner-image {
      width: 100%;
    }
    .news-room-heading {
      line-height: 4vw;
      margin-bottom: 2.42vw;
    }
    .news-room-sub-heading {
      font-size: 2.84vw;
      line-height: 3.5vw;
      margin-bottom: 2.42vw;
    }
  }
`;

const Box = styled.div`
  margin-bottom: min(2.94vw, 42px);
  gap: min(3.85vw, 55px);
  gap: 15px;
  padding: 15px;
  height: 200px;
  background: white;
  width: 80%;

  img {
    width: 100%;
    margin-top: 30px;
  }
  p {
    text-align: center;
    font-family: "robotoregular";
    color: #000;
  }

  @media (max-width: 767px) {
    height: 100px;
    padding: 10px;
    gap: 10px;
    img {
      width: 100%;
      margin-top: 0px;
    }
  }
`;

const Box2 = styled.div`
  margin-bottom: min(2.94vw, 42px);
  gap: min(3.85vw, 55px);
  gap: 15px;
  padding: 15px;
  height: 400px;
  width: 80%;
  background: white;

  h4 {
    font-size: min(1.47vw, 24px);
    line-height: min(1.68vw, 24px);
    color: #000;
    font-family: "robotobold";
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
  .report-container {
    display: flex;
    gap: 30px;
  }
  .headcut-image {
    height: 120px;
  }
  .main-sub {
    font-size: 20px;
  }

  p {
    text-align: inherit;
    font-family: "robotobold";
    color: #000;
  }
  .ship-img {
    width: 100%;
  }

  @media (max-width: 767px) {
    height: 225px;
    padding: 10px;
    gap: 10px;
    .headcut-image {
      width: 50px;
      height: 50px;
    }
    .main-sub {
      font-size: 10px;
    }
    .reporter {
      font-size: 10px;
    }
  }
`;

const Box3 = styled.div`
  margin-bottom: min(2.94vw, 42px);
  gap: min(3.85vw, 55px);
  gap: 15px;
  padding: 15px;
  height: 200px;
  width: 80%;
  background: white;

  h4 {
    font-size: 24px;
    line-height: min(1.68vw, 24px);
    color: #000;
    font-family: "robotobold";
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  img {
    height: 120px;
  }
  .main-sub {
    font-size: 30px;
  }
  p {
    text-align: inherit;
    font-size: 20px;
    font-family: "robotobold";
    color: #000;
  }
  a {
    color: blue !important;
    font-family: "robotobold";
  }
  a:hover {
    text-decoration: underline !important;
    font-weight: bold;
  }

  @media (max-width: 767px) {
    height: 100px;
    padding: 10px;
    gap: 10px;
    h4 {
      font-size: 9px;
    }
    img {
      width: 50px;
      height: 50px;
    }
    p {
      font-size: 10px;
    }
  }
`;
export { Container, Wrapper, Box, Box2, Box3 };
